import React from 'react';
import Promise from 'bluebird';
import { connect } from 'react-redux';
import { apply as addPromo } from 'components/promo/actions';
import { trackNow } from 'shared/models/analytic';
import { getLoggedInUser } from 'shared/models/api';
import { H3, H6 } from 'scy/text';
import { AltSecondaryButton } from 'scy/buttons';
import { uppercase } from 'scy/text/styles.mod.scss';
import {
  relative,
  absolute,
  top_xs,
  left_0,
  bottom_sm
} from 'scy/position.mod.scss';
import margin from 'scy/margin.mod.scss';
import padding from 'scy/padding.mod.scss';
import SignupForm from './signup';
import PostSignup from './postSignup';
import VerifyMobileHeader from './verifyMobileHeader';
import MobileVerification from './mobileVerification';
import LoadingSpinner from 'scy/LoadingSpinner';
import SlideContainer from 'components/SlideContainer';
import BackArrow from 'images/icons/controls/arrow-back.svg?react-svg';
import styles from './styles.mod.scss';

class SignupWithPromo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      promo: (props.promo || '').toUpperCase(),
      loading: false,
      postSignup: false,
      verifyMobile: false
    };
  }

  handleLogin(user) {
    if (user && user.mobileVerified) {
      return this.checkHasOrdered();
    } else {
      this.returningUser = true;
      this.promptVerifyMobile();
      return Promise.resolve();
    }
  }

  handleSignup(user) {
    if (user && user.mobileVerified) {
      return this.tryAddPromo();
    } else {
      this.promptVerifyMobile();
    }
  }

  promptVerifyMobile() {
    this.setState({ verifyMobile: true });
    if (this.props.onVerifyMobile) this.props.onVerifyMobile();
  }

  checkHasOrdered() {
    this.setState({ loading: true });
    const didEnterPromo = !!this.state.promo;
    if (!didEnterPromo) {
      if (this.props.shopNow) this.props.shopNow();
      else window.location = '/';
      return Promise.resolve();
    }

    return getLoggedInUser().then(res => {
      const { user } = res;
      if (user && user.orders && user.orders.length > 0) {
        return this.showPostSignup('not-new-user');
      } else {
        return this.tryAddPromo();
      }
    });
  }

  tryAddPromo() {
    this.setState({ loading: true });
    const attemptedCode = this.state.promo;
    if (!attemptedCode) {
      return this.showPostSignup('welcome');
    }

    trackNow('Coupon Entered', {
      source: 'signup',
      coupon: attemptedCode
    });

    return this.props.addPromo(attemptedCode).then(() => {
      const error = this.props.userPromo.error;
      const addedCode = this.props.userPromo.codes[0];

      if (error) {
        this.trackPromoFailure(attemptedCode, error);
        return this.showPostSignup('promo-invalid');
      } else {
        this.trackPromoSuccess(addedCode);
        return this.showPostSignup('promo-success');
      }
    });
  }

  trackPromoSuccess(addedCode) {
    trackNow('Coupon Applied', {
      source: 'signup',
      coupon_id: addedCode.code,
      coupon_name: addedCode.desc,
      discount: addedCode.val
    });
  }

  trackPromoFailure(attemptedCode, errorMsg) {
    trackNow('Coupon Denied', {
      source: 'signup',
      coupon: attemptedCode,
      reason: errorMsg
    });
  }

  showPostSignup(state) {
    if (state === 'welcome' && this.props.reloadOnSignup) {
      window.location.reload();
      return;
    }
    this.setState({ postSignup: state, loading: false });
    if (this.props.onPostSignup) this.props.onPostSignup();
    return Promise.resolve();
  }

  render() {
    return this.state.postSignup ? (
      <PostSignup
        message={this.state.postSignup}
        promoCodes={this.props.userPromo.codes}
        shopNow={this.props.shopNow}
      />
    ) : (
      <SlideContainer
        className={styles.slideContainer}
        showRight={this.state.verifyMobile}
        renderLeft={() => (
          <>
            {this.state.loading && <LoadingSpinner backdrop green />}
            <H3 tag="h1" marginClass={`${margin.top_0} ${margin.bottom_xs}`}>
              Get it poppin’
            </H3>
            <H6
              tag="h2"
              marginClass={`${margin.top_0} ${margin.bottom_sm}`}
              className={uppercase}
            >
              Craft beer, wine, spirits &amp; mixers delivered.
            </H6>
            <SignupForm
              compact={this.props.compact}
              promo={this.state.promo}
              onPromoChange={promo => this.setState({ promo })}
              onSuccess={user => this.handleSignup(user)}
              onFBSignup={user => this.handleSignup(user)}
              onFBLogin={user => this.handleLogin(user)}
              loading={this.state.loading}
            />
          </>
        )}
        renderRight={() => (
          <>
            <div className={`${relative} ${padding.sm}`}>
              <AltSecondaryButton
                noBorder
                className={`${absolute} ${top_xs} ${bottom_sm} ${left_0}`}
                onClick={() => this.setState({ verifyMobile: false })}
                Icon={BackArrow}
              />
              <VerifyMobileHeader />
            </div>
            <div className={`${padding.left_sm} ${padding.right_sm}`}>
              <MobileVerification
                onSuccess={() => {
                  if (this.returningUser) {
                    this.checkHasOrdered();
                  } else {
                    this.tryAddPromo();
                  }
                }}
              />
            </div>
          </>
        )}
      />
    );
  }
}

export default connect(
  state => ({
    userPromo: state.promo,
    login: state.login
  }),
  {
    addPromo
  }
)(SignupWithPromo);
